<template>
       
	<Submenu :name="parentItem.id+'A'">
		<template slot="title" >
			<div class="flexC" style="width:130px">
			   <i  class="iconfont" :class="parentItem.icon" style="font-size: 17px;margin-right:8px"></i>
			   <div style="height:25px;line-height:25px">{{showTitle(parentItem)}}</div>
			</div>
		</template>
		<MenuItem :name="parentItem.id+'-'+item2.id" v-for="(item2,index2) in children" :key="index2">
		    <div class="flexC" style="">
				<Icon type="ios-paper" style="height:21px;line-height:21px;margin-right:5px" />
		    	<div style="height:21px;line-height:21px">{{showTitle(item2)}}</div>
		    </div>
		</MenuItem>
	</Submenu>
	
</template>
<script>
import mixin from './mixin'
import itemMixin from './item-mixin'
export default {
  name: 'SideMenuItem',
  mixins: [ mixin, itemMixin ]
}
</script>
<style lang='less' scoped>

	.ivu-menu-vertical .ivu-menu-item:hover,
	.ivu-menu-vertical .ivu-menu-submenu-title:hover{
		background: #fff !important;
		color: #4ABAF0 !important;
		border-radius: 10px;
		
	}
	.ivu-menu-submenu{
		text-align: center;
	}
	.ivu-menu-item>i {
       margin-right: 10px;
    }
	.ccc{
		/deep/.ivu-menu-vertical .ivu-menu-submenu-title{
	    	padding: 14px 100px !important;
	    }

	}


</style>

<style scoped>


	/* 菜单悬浮高亮 */
	/* .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover {
		background: #4ABAF0;
		color: #ffffff;
		border-radius: 10px;
		
	} */

	.ivu-menu-vertical .ivu-menu-submenu-title{
	    	padding: 14px 100px !important;
	    }

	.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
		color: #ffffff !important;
		background-color:#4ABAF0  !important;
		border-radius: 10px;
		margin: 0 30px;
	}

	.ivu-menu-light.ivu-menu-vertical .ivu-menu-item{
		margin: 0 30px;
		padding-left: 80px !important;
		display: flex;
		justify-content: flex-start;
	}


	.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
		background: #fff;
	}
	.ivu-menu-vertical.ivu-menu-light:after{
		background: #fff;
	}


	.layout-con {
		height: 100%;
		width: 100%;
	}

	.menu-item span {
		display: inline-block;
		overflow: hidden;
		width: 69px;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: bottom;
		transition: width 0.2s ease 0.2s;
	}

	.menu-item i {
		transform: translateX(0px);
		transition: font-size 0.2s ease, transform 0.2s ease;
		vertical-align: middle;
		font-size: 16px;
	}

	.collapsed-menu span {
		width: 0px;
		transition: width 0.2s ease;
	}

	.collapsed-menu i {
		transform: translateX(5px);
		transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
		vertical-align: middle;
		font-size: 22px;
	}

	.ivu-form .ivu-form-item-label {
		max-width: 120px !important;
		text-align: center !important;
		text-indent: 1px;
	}

	.ivu-form-item-content {
		margin-left: 120px !important;
	}

	::-webkit-scrollbar {
		width: 0px;
		height: 4px;
	}

	/*滑动轨道*/
	::-webkit-scrollbar-track {
		border-radius: 0px;
		background: none;
	}

	/*滑块*/
	::-webkit-scrollbar-thumb {
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		background-color: rgba(255, 255, 255, 0.75);
	}

	/*滑块效果*/
	::-webkit-scrollbar-thumb:hover {
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		background-color: rgba(85, 85, 85, 0.4);
	}

	.menu-view {
		width: 100% !important;
	}




  
</style>